import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { logoutUser,OliLogoutUser } from '../services/apiService';

interface AuthContextType {
  isLoggedIn: boolean;
  login: () => void;
  logout: () => void;
  oliLogin: () => void;
  oliLogout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider = ({ children }: { children: ReactNode }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isOliLoggedIn, setIsOliLoggedIn] = useState(false);

  useEffect(() => {
    const loggedIn = localStorage.getItem('isLoggedIn') === 'true';
    setIsLoggedIn(loggedIn);
  }, [isLoggedIn]);

  const login = async () => {
    setIsLoggedIn(true);
    localStorage.setItem('isLoggedIn', "true");
    setIsOliLoggedIn(false);
    localStorage.setItem('isOliLoggedIn', "false");
    window.location.reload();
  };

  const oliLogin = async () => {
    setIsOliLoggedIn(true);
    localStorage.setItem('isOliLoggedIn', "true");
    setIsLoggedIn(false);
    localStorage.setItem('isLoggedIn', "false");
  };

  const logout = async () => {
    setIsLoggedIn(false);
    localStorage.setItem('isLoggedIn', 'false');
    localStorage.removeItem('token');
    await logoutUser();
    window.location.reload();
  };

  const oliLogout = async () => {
    setIsOliLoggedIn(false);
    localStorage.setItem('isOliLoggedIn', 'false');
    localStorage.removeItem('OliToken');
    await OliLogoutUser();
    window.location.reload();
  };

  return (
    <AuthContext.Provider value={{ isLoggedIn, login, logout, oliLogin, oliLogout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};
